// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__H4SP3"};